var scope_0 = require('/opt/build/repo/gatsbynetlify/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/24dfd0030174d9ed144f90fa41ee9005.js').default;export default
        Object.assign({}, scope_0 )
    